import React, { useEffect, useState } from 'react';
import "../Styles/CreateUser.css";
import * as yup from "yup";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { ErrorMessage, Formik, Form, Field } from "formik";
import Axios from "axios";
import { toast, ToastContainer, toast as toastHelper } from 'react-toastify';

import CloudProHeader from './CloudProHeader';
const CloudProMDCreateT = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mdId } = useParams();
  const siId = localStorage.getItem("siId");

  const hasSi = siId !== null && siId !== undefined && String(siId).trim() !== "";

  const ROLE_NAME_TO_ID = hasSi ? { Admin: 1, Technician: 2 } : { Admin: 3, Technician: 4 };

  const handleBack = () => {
    toastHelper.dismiss();
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
      console.log("Navigating back one step.");
    } else {
      navigate('/dashboard', { replace: true });
      console.log("No history to go back, redirecting to dashboard.");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('@user');
    localStorage.removeItem('userEmail');
    toastHelper.dismiss();
    navigate('/', { replace: true });
  };

  const handleCreateUser = (values, { resetForm }) => {
    Axios.post(`/create_company_user`, {
      mdId: mdId,
      siId: hasSi ? String(siId).trim() : null,
      firstname: values.firstname,
      lastname: values.lastname,
      email: values.email,
      yubikey: values.yubikeyserialnumber,
      adminEmail: localStorage.getItem('userEmail'),
      role: ROLE_NAME_TO_ID[values.role] ?? ROLE_NAME_TO_ID.Technician,
    }).then((response) => {
      if (response && response.data && response.data.success) {
        toast.success(response.data.msg || "User created successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        resetForm();
      } else {
        toast.error(response.data.msg || "Failed to add user, please try again!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }).catch(() => {
      toast.error("Failed to add user, please try again!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    });
  };

  const validationsCreateUser = yup.object().shape({
    firstName: yup.string().required("First name is mandatory"),
    lastName: yup.string().required("Last name is mandatory"),
    email: yup.string().email("Invalid email").required("Email is mandatory"),
  });

  return (
    
    <>
    <CloudProHeader isAdmin={true} />
       <div className="main-container">
    
             <div className="login-card">
              
               <h2 className="title">Create User In Your Company</h2>
        <Formik
          initialValues={{
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            yubikeySerialNumber: '',
            role: 'Technician',
          }}
          onSubmit={handleCreateUser}
          validationSchema={validationsCreateUser}
        >
         <Form className="register-form">
         
           <div className="input-group">
             <label>First Name</label>
              <Field name="firstName" type='text'  style={{left: "0%"}} placeholder="Enter First name" />
              <ErrorMessage component="span"
      name="firstName"
      className="adduser-form-error" />
            </div>

            <div className="input-group">
              <label>Last Name</label>
              <Field name="lastName" type='text'  placeholder="Enter Last name" />
              <ErrorMessage component="span" name="lastName" className="adduser-form-error" />
            </div>

            <div className="input-group">
              <label>Email</label>
              <Field name="email" type='text' style={{left: "0%"}} placeholder="Enter Email" />
              <ErrorMessage component="span" name="email" className="adduser-form-error" />
            </div>

            <div className="input-group">
              <label>Role</label>
              <Field as="select" name="Role" style={{left: "0%"}}>
                <option value="Technician">Technician</option>
                <option value="Admin">Admin</option>
              </Field>
            </div>

            <div className="input-group">
              <label>Yubikey Serial Number</label>
              <Field name="yubikeySerialNumber" type='text' style={{left: "0%"}} placeholder="Enter VELOX Cloud Key Serial Number" />
            </div>

            <button className="signin-btn" type="submit">
              Create User
            </button>
          </Form>
        </Formik>
        
      </div>
      </div>
    </>
  );
};

export default CloudProMDCreateT;